module.exports = __webpack_public_path__ + "img/iphone-hero-question-03.2eedfbfb.png";